/* The + of every product card (request 169): category, search, home, and the product page's Works with, Same family and
   More in. A card carries its versions as data-qa, [[code, options, variant], ...]. One version is added at once;
   several open a short list to choose from, so a version is never picked for the buyer (Shopify's own quick add adds
   the first one). Within the quote list limits (theme settings, window.LuzLimits). On
   the product page the add goes through the page's own drawer (window.LuzProduct); elsewhere the button turns to a tick
   and a short confirmation links to the list (kept in the browser, assets/luz-list.js). Cards built later (search) need
   nothing: clicks are read on the document. */
(() => {
  const ROOT = window.Shopify?.routes?.root || "/";
  const { lines: MAX_LINES, qty: MAX_QTY } = window.LuzLimits;
  const PLUS = '<path d="M12 5v14M5 12h14"/>', TICK = '<path d="M5 12.5l4.5 4.5L19 7.5"/>';
  const esc = (t) => String(t ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);
  const noimg = '<svg viewBox="0 0 48 48" aria-hidden="true" style="width:24px;height:24px;fill:none;stroke:#b3b8b4;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round"><path d="M24 6v6M9.5 12.5l4 4M38.5 12.5l-4 4M16 30a8 8 0 1 1 16 0c0 3-2 4.5-3 6.5h-10c-1-2-3-3.5-3-6.5ZM19 41h10"/></svg>';

  let toast = null, toastTimer = 0;
  const say = (html, plain) => {
    toast?.remove();
    clearTimeout(toastTimer);
    toast = document.createElement("div");
    toast.className = `qa-toast${plain ? " plain" : ""}`;
    toast.setAttribute("role", "status");
    toast.innerHTML = html;
    document.body.append(toast);
    toastTimer = setTimeout(() => { toast?.remove(); toast = null; }, 5000);
  };

  const add = (btn, ver, name, img) => {
    const [code, opts, variant] = ver;
    const label = opts ? `${name}, ${opts}` : name;
    /* The card's own address; the quote list page brings it to the version's own (assets/luz-list.js). */
    const url = btn.closest(".lp-card, .lc-card, article, li")?.querySelector("a[href]")?.getAttribute("href") || "";
    const info = { name, code, option: opts, img, url };
    /* The product page: its drawer shows what was added and the rest of the list. */
    if (window.LuzProduct?.add) return window.LuzProduct.add(variant, 1, info);
    const r = window.LuzList.add({ v: variant, n: name, c: code, o: opts, i: img, u: url }, 1, "luz-quick-add");
    if (r.blocked) return say(`<span>${esc(window.LuzList.BLOCKED)}</span>`, true);
    if (r.full === "list")
      return say(`<span>Your quote list holds up to ${MAX_LINES} products. Send it, then start a new list for the rest.</span><a href="${ROOT}cart">View quote list</a>`);
    if (r.full) return say(`<span>Your list already holds ${MAX_QTY.toLocaleString("en")} of <b>${esc(label)}</b>, the most one list takes.</span><a href="${ROOT}cart">View quote list</a>`);
    say(`<span class="i">${img ? `<img src="${esc(img)}" alt="">` : noimg}</span><span>${r.q > r.added ? `One more <b>${esc(label)}</b>` : `<b>${esc(label)}</b> added`}` +
      `<small>${esc(code)} · ${r.count} ${r.count === 1 ? "product" : "products"} in your list</small></span><a href="${ROOT}cart">View quote list</a>`);
    const svg = btn.querySelector("svg");
    if (svg) {
      btn.classList.add("done");
      svg.innerHTML = TICK;
      setTimeout(() => { btn.classList.remove("done"); svg.innerHTML = PLUS; }, 1800);
    }
  };

  /* The list of versions, under the button, or above it when there is no room below; inside the screen on phones. */
  let pop = null, owner = null;
  const closePop = (focus) => {
    if (!pop) return;
    pop.remove();
    pop = null;
    owner?.setAttribute("aria-expanded", "false");
    if (focus) owner?.focus();
    owner = null;
  };
  const openPop = (btn, vers, name, img) => {
    closePop();
    owner = btn;
    btn.setAttribute("aria-expanded", "true");
    pop = document.createElement("div");
    pop.className = "qa-pop";
    pop.setAttribute("role", "dialog");
    pop.setAttribute("aria-label", `Versions of ${name}`);
    pop.innerHTML = `<div class="qa-h">Add to quote list<b>${esc(name)}</b></div>` + vers.map((v, n) =>
      `<button type="button" class="qa-row" data-n="${n}"><span><b>${esc(v[1] || v[0])}</b><small>${esc(v[0])}</small></span>` +
      `<svg viewBox="0 0 24 24" aria-hidden="true">${PLUS}</svg></button>`).join("");
    document.body.append(pop);
    const b = btn.getBoundingClientRect(), w = pop.offsetWidth, h = pop.offsetHeight;
    const left = Math.max(12, Math.min(innerWidth - w - 12, b.right - w));
    const below = b.bottom + 8 + h <= innerHeight - 12;
    pop.style.left = `${left}px`;
    pop.style.top = `${below ? b.bottom + 8 : Math.max(12, b.top - 8 - h)}px`;
    pop.addEventListener("click", (e) => {
      const row = e.target.closest(".qa-row");
      if (!row) return;
      const b2 = owner;
      closePop();
      add(b2, vers[+row.dataset.n], name, img);
      b2?.focus();
    });
    pop.querySelector(".qa-row")?.focus();
  };

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-qa]");
    if (!btn) {
      if (pop && !e.target.closest(".qa-pop")) closePop();
      return;
    }
    e.preventDefault();
    if (btn === owner) return closePop();
    let vers = [];
    try { vers = JSON.parse(btn.dataset.qa); } catch {}
    if (!vers.length) return;
    const name = btn.dataset.qaName || "";
    if (vers.length === 1) add(btn, vers[0], name, btn.dataset.qaImg);
    else openPop(btn, vers, name, btn.dataset.qaImg);
  });
  document.addEventListener("keydown", (e) => {
    if (!pop) return;
    if (e.key === "Escape") { e.preventDefault(); closePop(true); return; }
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      const rows = [...pop.querySelectorAll(".qa-row")];
      const i = rows.indexOf(document.activeElement);
      rows[(i + (e.key === "ArrowDown" ? 1 : rows.length - 1)) % rows.length]?.focus();
      e.preventDefault();
    }
  });
  addEventListener("resize", () => closePop());
  addEventListener("scroll", () => closePop(), { passive: true });
})();
